module.exports = __webpack_public_path__ + "media/images/pages/gender-balance/hero-938849c60db12c43a6d877bacfac71e7.jpg";